import React from 'react';

const TagGrupo = (props) => {
    return (
        <li className="bottom-separator-xxs">
            <div className="btn-group">
                <button type="button" className="btn-tag btn-tag-big btn-tag-closable btn-tag-closable-left not-clickable">{props.descripcion}</button>
                <button type="button" className="btn-tag btn-tag-big btn-tag-closable btn-tag-closable-right"
                    onClick={() => props.deleteGroupWindows(props.id)}>
                    <span key={props.key} className="ti-close span-closable" title="Quitar grupo."></span>
                </button>
            </div>
        </li>);
}

export default TagGrupo;